import { render, staticRenderFns } from "./teamLogInfo.vue?vue&type=template&id=23a18ec3&scoped=true&lang=pug&"
import script from "./teamLogInfo.vue?vue&type=script&lang=js&"
export * from "./teamLogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a18ec3",
  null
  
)

export default component.exports